import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { css } from "styled-components";

quantityOrderedStyles.quantityOrdered = {
    cssOverrides: {
        formField: css`
            margin: 5px 0 15px 0;
            max-width: 100px;
        `,
    },
    labelProps: {
        weight: "normal",
    },
};
